import { trigger, transition, style, animate } from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { FormAutomation } from "src/app/form/form-automation";
import { Library } from "src/app/models/library";
import { ActionService } from "src/app/services/action.service";
import { Globals } from "src/app/services/globals";
import { DataPool } from "src/app/services/message.service";

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: [
    "./password-reset.component.scss",
    "../login/login.component.scss",
    "../template/template.component.scss",
  ],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ height: "45px", opacity: 1 }),
        animate("1s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("inAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class PasswordResetComponent implements OnInit {
  FormAutomation = FormAutomation;

  constructor(private dataService: ActionService, private dataPool: DataPool) {}

  submitted = false;
  ngOnInit(): void {
    this.submitted = false;
  }

  email = "";
  resetPassword() {
    this.submitted = true;
    this.dataService.requestPasswordReset({
      library: new Library(Globals.LastSelectedLibraryId, true, ""),
      email: this.email,
    });
  }

  get isConnected() {
    return this.dataPool.isConnected;
  }
}
